module.exports = __webpack_public_path__ + "img/emptyProduct.png";